import React, { Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import WebsiteProtectedRoute from "../../../components/authorization/ProtectedRoute/WebisteProtectedRoute";
import { FullPageLoading } from "../../../components/ui/Loading";
import { lazyLoadComponent } from "../../../utils/react";
import BookingWidget from "../../../widgets/Booking";

import PropertyLandingPage from "../pages/PropertyLanding";
import UserBookingInfo from "../pages/UserBookingInfo";
import UserDashboardPage from "../pages/UserDashboard";
import UserSignIn from "../pages/UserSignIn";
import WhatsAppLogin from "../pages/WhatsAppLogin";
const BookingConfirmPage = lazyLoadComponent(
  () => import("../pages/BookingConfirm")
);
const BookingInfoPage = lazyLoadComponent(() => import("../pages/BookingInfo"));
const GuestPolicyPage = lazyLoadComponent(() => import("../pages/GuestPolicy"));
const TermsPage = lazyLoadComponent(() => import("../pages/Terms"));
const USPage = lazyLoadComponent(() => import("../pages/USPage/Page"));
const DreamPage = lazyLoadComponent(() => import("../pages/Dream"));
const MerchandisePage = lazyLoadComponent(() => import("../pages/Merchandise"));
const MerchandiseTshirtPage = lazyLoadComponent(
  () => import("../pages/MerchandiseTshirtPage")
);
const MerchandiseBagsPage = lazyLoadComponent(
  () => import("../pages/MerchandiseBagsPage")
);
const UserAccount = lazyLoadComponent(() => import("../pages/UserAccount"));
const PrivacyPolicyPage = lazyLoadComponent(
  () => import("../pages/PrivacyPolicy")
);
const CookiePolicyPage = lazyLoadComponent(
  () => import("../pages/CookiePolicy")
);
const AboutUsPage = lazyLoadComponent(() => import("../pages/AboutUs"));
const ContactUsPage = lazyLoadComponent(() => import("../pages/ContactUs"));
const DestinationPage = lazyLoadComponent(() => import("../pages/Destination"));
const NotFoundPage = lazyLoadComponent(() => import("../pages/NotFound"));
const LongStays = lazyLoadComponent(() => import("../pages/LongStays"));
const PaymentResponsePage = lazyLoadComponent(
  () => import("../pages/PaymentResponse")
);
const TripBookingInfoPage = lazyLoadComponent(
  () => import("../pages/TripBookingInfo.tsx")
);
const UserBookings = lazyLoadComponent(() => import("../pages/UserBookings"));
const PropertyPage = lazyLoadComponent(() => import("../pages/Property"));
const ExplorePage = lazyLoadComponent(() => import("../pages/Explore"));
const HomePage = lazyLoadComponent(() => import("../pages/Homes"));
const PlaylistPage = lazyLoadComponent(() => import("../pages/Playlist"));
const ZostelPage = lazyLoadComponent(() => import("../pages/Zostel"));
const ZostelPlusPage = lazyLoadComponent(() => import("../pages/ZostelPlus"));
const ZoTripsPage = lazyLoadComponent(() => import("../pages/ZoTrips"));

const BlogPage = lazyLoadComponent(() => import("../pages/Blog"));
const BlogShowPage = lazyLoadComponent(() => import("../pages/BlogShow"));
const EDPPage = lazyLoadComponent(() => import("../pages/EDP"));
const TripBookingConfirmPage = lazyLoadComponent(
  () => import("../pages/TripBookingConfirm")
);
const UnderConstructionPage = lazyLoadComponent(
  () => import("../pages/UnderConstruction")
);
const DestinationsPage = lazyLoadComponent(
  () => import("../pages/Destinations")
);
const COVIDFaqsPage = lazyLoadComponent(() => import("../pages/COVIDFaqs"));
// const TravelForTomorrowPage = lazyLoadComponent(
// () => import("../pages/TravelForTomorrow")
// );
const RoomSelector = lazyLoadComponent(
  () => import("../../../widgets/RoomSelector")
);
const InternshipAtZostel = lazyLoadComponent(
  () => import("../pages/InternshipAtZostel")
);

const CareersPage = lazyLoadComponent(
  () => import("../pages/Career/CareersPage")
);
const CareerInfoPage = lazyLoadComponent(
  () => import("../pages/Career/CareerInfoPage")
);
const TravelShootAndLearn = lazyLoadComponent(
  () => import("../pages/TravelShootAndLearn")
);
const MobileAppPage = lazyLoadComponent(() => import("../pages/MobileApp"));
const CaseStudyPage = lazyLoadComponent(() => import("../pages/CaseStudy"));
const ExperiencePage = lazyLoadComponent(() => import("../pages/Experience"));
const TripPage = lazyLoadComponent(() => import("../pages/Trips"));
const ArtistCollaborationProgramPage = lazyLoadComponent(
  () => import("../pages/ArtistCollaborationProgramPage")
);
const TravelAgencyPartnerProgramPage = lazyLoadComponent(
  () => import("../pages/TravelAgencyPartnerProgram")
);
const TourOperatorPartnerProgramPage = lazyLoadComponent(
  () => import("../pages/TourOperatorPartnerProgram")
);
const CaptureTheVibeOfZostelPage = lazyLoadComponent(
  () => import("../pages/CaptureTheVibeOfZostelPage")
);
const DesignZostelsNextFranchisePage = lazyLoadComponent(
  () => import("../pages/DesignZostelsNextFranchisePage")
);
const MakeWallArtAtZostelPage = lazyLoadComponent(
  () => import("../pages/MakeWallArtAtZostelPage")
);
const ShapeTheLookOfAZostelPage = lazyLoadComponent(
  () => import("../pages/ShapeTheLookOfAZostelPage")
);

const EscapeListPage = lazyLoadComponent(() => import("../pages/Escape"));
const EscapePage = lazyLoadComponent(
  () => import("../pages/Escape/EscapePage")
);
const CheckinPage = lazyLoadComponent(() => import("../pages/Checkin"));
const CheckinDashboard = lazyLoadComponent(
  () => import("../pages/CheckinDashboard")
);

interface RoutesProps {}

const Routes: React.FC<RoutesProps> = () => {
  return (
    <Suspense fallback={<FullPageLoading text="Follow your ❤️" />}>
      <Switch>
        <WebsiteProtectedRoute
          path="/dashboard"
          component={UserDashboardPage}
        />
        <Route path="/me/bookings" component={UserBookings} />
        <WebsiteProtectedRoute path="/me/profile" component={UserAccount} />
        <WebsiteProtectedRoute
          path="/booking-info/:code/"
          component={UserBookingInfo}
        />
        <Route path="/policy" component={GuestPolicyPage} />
        <Route path="/signin" component={UserSignIn} />
        <Route path="/dashboard" component={UserDashboardPage} />
        <Route path="/dream" component={DreamPage} />
        <Route path="/privacy" component={PrivacyPolicyPage} />
        <Route path="/merchandise/tshirt" component={MerchandiseTshirtPage} />
        <Route path="/merchandise/bags" component={MerchandiseBagsPage} />
        <Route path="/merchandise" component={MerchandisePage} />
        <Route path="/auth" component={WhatsAppLogin} />
        <Route path="/terms" component={TermsPage} />
        <Route path="/faq/covid-19" component={COVIDFaqsPage} />
        <Route path="/cookie-policy" component={CookiePolicyPage} />
        <Route path="/about" component={AboutUsPage} />
        <Route path="/contact" component={ContactUsPage} />/
        <Route
          path="/franchise/case-study/:propertySlug"
          component={CaseStudyPage}
        />
        <Route path="/list/:slug" component={PlaylistPage} />
        <Route path="/franchise/new" component={EDPPage} />
        <Route path="/franchise" component={DreamPage} />
        <Route path="/blog/:slug" component={BlogShowPage} />
        <Route path="/blog" component={BlogPage} />
        <Route path="/payment-response" component={PaymentResponsePage} />
        <Route path="/longstays" component={LongStays} />
        <Route path="/movein" component={LongStays} />
        <Route path="/booking/:code" component={BookingInfoPage} />
        <Route path="/created" component={BookingInfoPage} />
        <Route path="/booking" component={BookingConfirmPage} />
        <Route path="/zostel" exact component={ZostelPage} />
        <Route path="/destinations" exact component={DestinationsPage} />
        <Route
          path="/widgets/room-selector/:propertyId/"
          component={RoomSelector}
        />
        <Route path="/widgets/booking/" component={BookingWidget} />
        <Route
          path="/homes/:destinationSlug/:propertySlug"
          component={PropertyPage}
        />
        <Route
          path="/zostel/:destinationSlug/:propertySlug"
          component={PropertyPage}
        />
        <Route path="/homes" component={HomePage} />
        <Route path="/zostel-plus" component={ZostelPlusPage} />
        <Route
          path="/campsites/:destinationSlug/:propertySlug"
          component={PropertyPage}
        />
        <Route
          path="/resorts/:destinationSlug/:propertySlug"
          component={PropertyPage}
        />
        <Route
          path="/hotels/:destinationSlug/:propertySlug"
          component={PropertyPage}
        />
        <Route
          path="/trusted-by-zostel/:destinationSlug/:propertySlug"
          component={PropertyPage}
        />
        <Redirect
          from="/homes/zostelx/:destinationSlug"
          to="/zostel/:destinationSlug"
        />
        <Redirect
          from="/trusted-by-zostel/:destinationSlug"
          to="/zostel/:destinationSlug"
        />
        <Route path="/book/:propertyCode" component={PropertyLandingPage} />
        <Route path="/zostel/:destinationSlug" component={DestinationPage} />
        <Route
          path="/checkin/:propertyCode/:bookingCode"
          component={CheckinPage}
        />
        <Route path="/checkin/:propertyCode" component={CheckinPage} />
        <Route
          path="/checkin-dashboard/:propertyCode"
          component={CheckinDashboard}
        />
        <Route path="/zo-trips" component={ZoTripsPage} />
        <Route
          path="/under-construction"
          exact
          component={UnderConstructionPage}
        />
        <Redirect from="/join" to="/" exact />
        <Route
          path="/join/travel-shoot-and-learn"
          exact
          component={TravelShootAndLearn}
        />
        <Route
          path="/join/artists-collaboration-program"
          exact
          component={ArtistCollaborationProgramPage}
        />
        <Route
          path="/join/travel-agency-partner-program"
          exact
          component={TravelAgencyPartnerProgramPage}
        />
        <Route
          path="/join/tour-operator-partner-program"
          exact
          component={TourOperatorPartnerProgramPage}
        />
        <Route
          path="/join/capture-the-vibe-of-zostel"
          exact
          component={CaptureTheVibeOfZostelPage}
        />
        <Route
          path="/join/design-zostels-next-franchise"
          exact
          component={DesignZostelsNextFranchisePage}
        />
        <Route
          path="/join/make-wall-art-at-zostel"
          exact
          component={MakeWallArtAtZostelPage}
        />
        <Route
          path="/join/shape-the-look-of-a-zostel"
          exact
          component={ShapeTheLookOfAZostelPage}
        />
        <Route path="/app" exact component={MobileAppPage} />
        <Redirect from="/join/volunteer-at-hostel" to="/internship" />
        <Route path="/join/internship" exact component={InternshipAtZostel} />
        <Route path="/career/:slug" exact component={CareerInfoPage} />
        <Route path="/career" exact component={CareersPage} />
        <Route path="/escape" exact component={EscapeListPage} />
        <Route
          path="/escape/:destinationSlug/:escape"
          exact
          component={EscapePage}
        />
        <Route
          path="/trip/:destinationSlug/:escape"
          exact
          component={ExperiencePage}
        />
        <Route path="/trips/:slug" exact component={TripPage} />
        <Route
          path="/trips/booking/info/:slug"
          exact
          component={TripBookingInfoPage}
        />
        <Route
          path="/trips/booking/confirm/"
          exact
          component={TripBookingConfirmPage}
        />
        <Redirect from="/trips/" to="/zo-trips" />
        {/* <Redirect
          from="/trips/:destinationSlug/:escape"
          to="/trip/:destinationSlug/:escape"
        /> */}
        <Route path="/" exact component={ExplorePage} />
        {
          // disable for production
          process.env.REACT_APP_ENV !== "production" && (
            <Route path="/us" exact component={USPage} />
          )
        }
        <Route component={NotFoundPage} />
      </Switch>
    </Suspense>
  );
};

export default Routes;
